export default "__VITE_ASSET__BIrDZPYj__"